import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: BASE ? `${BASE}/api` : undefined, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = sessionStorage.getItem("wnx_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const hasBackend = Boolean(BASE);

export function errorText(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return d?.msg || "Something went wrong.";
}

export const imgSrc = (src) => src || "";
